import React from 'react';

import { Link } from 'react-router-dom';

import Breadcrumbs from '@mui/material/Breadcrumbs';

import Tooltip from '@mui/material/Tooltip';

import { usePageTitle } from 'utils/hooks/usePageTitle';

import { MainHeaderProps } from './types';
import { HeaderWrapper, HeaderTitle, HeaderTitleWrapper, ItemLabel, BreadcrumbText, BreadcrumbLink } from './styles';

export const MainHeader: React.FunctionComponent<MainHeaderProps> = ({
  title,
  breadcrumbs,
  action,
  customHeaderTitle,
  readonlyBreadcrumbs = false,
  documentTitle,
}): React.ReactElement => {
  usePageTitle(documentTitle ?? title);

  return (
    <HeaderWrapper>
      <HeaderTitleWrapper>
        <Breadcrumbs separator=">" aria-label="breadcrumb">
          {breadcrumbs.map((item, index) => {
            if (index === breadcrumbs.length - 1 || readonlyBreadcrumbs) {
              return <ItemLabel key={item.label}>{item.label}</ItemLabel>;
            }

            if (!item.link) {
              return <BreadcrumbText key={item.label}>{item.label}</BreadcrumbText>;
            }

            return (
              <BreadcrumbLink key={item.label} to={item.link} as={Link}>
                {item.label}
              </BreadcrumbLink>
            );
          })}
        </Breadcrumbs>
        {customHeaderTitle || (
          <Tooltip title={title.length > 60 ? title : ''}>
            <HeaderTitle id={`record-title-${title}`}>{title}</HeaderTitle>
          </Tooltip>
        )}
      </HeaderTitleWrapper>
      {action}
    </HeaderWrapper>
  );
};

export default MainHeader;
